<!--
This component is for creating pass
-->
<template>
  <div class="wrapper">
    <dashboardNav/>
    <!-- Page Content  -->
    <div id="content">
      <div class="container">
        <!-- Alerts -->
      </div>

      <!-- Page Content  -->
      <div class="main container">
        <loader :isLoading="requestInProgress"/>
        <h2>Passes</h2>
        <div class="line"></div>

        <PassForm
          :form="form"
          :isForm="isForm"
          :error="error"
          :action="action"
          :isOrganizer="isOrganizer"
          :validateBeforeSubmit="validateBeforeSubmit"
          :agreementCategories="agreementCategories"
          :userDetailCategories="userDetailCategories"
          :error_message="error_message"
          :updateErrorState="updateErrorState"
          :addFormQuestion="addFormQuestion"
          :deleteFormQuestion="deleteFormQuestion"
          submitButtonName="Add Pass"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DateDropdown from 'vue-date-dropdown'
import VueTimepicker from 'vue2-timepicker'

import Loader from '@/components/common/Loader'
import DashboardNav from '@/components/common/DashboardNav'
import InputComponent from '@/components/form/InputComponent'
import PassForm from '@/components/passes/PassForm'

import Sidebar from '@/containers/dashboard/Sidebar'

import { APIService } from '@/api/APIService'
import { AuthService } from '@/api/AuthService'
import { CommonHelper } from '@/api/helper/CommonHelper'
import { DateTimeHelper } from '@/api/helper/DateTimeHelper'
import { TIME_PICKER_FORMAT } from '@/api/constants/Common'
import { USER_DETAIL_CATEGORIES } from '@/api/constants/Business'

const api = new APIService()
const auth = new AuthService()
const common = new CommonHelper()
const date = new DateTimeHelper()

export default {
  components: {
    'date-dropdown': DateDropdown,
    'vue-timepicker': VueTimepicker,
    sidebar: Sidebar,
    dashboardNav: DashboardNav,
    Loader,
    InputComponent,
    PassForm
  },
  data() {
    return {
      form: {
        pass_name: '',
        type_of_pass: '',
        company_logo: '',
        company_name: '',
        company_email: '',
        visiting_date: date.getDateToday(),
        validity_date: date.getDateToday(),
        disposal_date: '15 days',
        visit_time: TIME_PICKER_FORMAT,
        valid_time: TIME_PICKER_FORMAT,
        floor_number: '',
        building_name: '',
        building_address: '',
        reason_for_visit: '',
        reason_for_collecting: '',
        contact_person: '',
        contact_email: '',
        pass_intro: '',
        pass_access_questions: [
          { type:'text', question: '' }
        ],
        included_pass_details: ['Full Name'],
        visiting_agreements: [],
        verify_identity: false,
        request_access: false,
        request_needs_approval: false
      },
      epochVisitDateTime: '',
      epochValidDateTime: '',
      epochDisposalDate: '',
      action: 'create',
      userId: auth.getUserId(),
      companyId: auth.getCompanyId(),
      isOrganizer: auth.getIsEventOrganizer(),
      account_type: '',
      userDetailCategories: USER_DETAIL_CATEGORIES,
      // agreementCategories: AGREEMENTS_CATEGORIES,
      agreementCategories: [],
      error: {
        visit_date: '',
        visit_time: '',
        valid_date: '',
        valid_time: '',
        disposal_date: '',
        included_pass_details: '',
        visiting_agreements: '',
        message: ''
      },
      error_message: '',
      isForm: true,
      haveError: false,
      isInvalidVuelidate: false,
      requestInProgress: false
    }
  },
  mounted() {
    this.getBusinessAgreements()
    this.getUserDetails()
  },
  methods: {
    async getUserDetails() {
      try {
        const userDetail = await api.getUserDetails(this.userId)
        const companyDetails = userDetail.profile_details.company_details
        this.form.company_name = companyDetails.company_name
        this.form.company_logo = companyDetails.company_logo
        this.form.company_email = userDetail.email_address
        if(!this.isOrganizer) {
          this.form.building_name = companyDetails.building_name
          this.form.building_address = companyDetails.building_address
        }
      } catch(e) {
        this.redirectToLogin()
      }
    },
    async getBusinessAgreements() {
      this.requestInProgress = true
      const businessAgreements = await api.getBusinessAgreementsByUserID(this.companyId)
      this.agreementCategories = businessAgreements.map(d => {
        if(d.agreement_name === 'Data Privacy Agreement' ||
          d.other_agreement_name === 'Data Privacy Agreement') {
          this.form.visiting_agreements.push(d.id)
        }
        return {
          id: d.id,
          name: d.agreement_name,
          other_name: d.other_agreement_name,
          date_created: d.date_created
        }
      }).sort((a, b) => { return a.date_created - b.date_created })
      this.requestInProgress = false
    },
    addFormQuestion() {
      if(this.form.pass_access_questions.length < 5) {
        this.form.pass_access_questions.push({ type: 'text', question: '' })
      }
    },
    deleteFormQuestion(i) {
      if(this.form.pass_access_questions.length > 1) {
        this.form.pass_access_questions.splice(i, 1)
      }
    },
    updateErrorState(value) {
      this.isInvalidVuelidate = value
    },
    validateBeforeSubmit() {
      this.error = {}
      this.haveError = false
      this.error_message = ''

      if (this.form.type_of_pass.length === 0) {
        this.error.type_of_pass = 'Please select type of pass'
        this.haveError = true
      }

      // TODO: check if vistingTime is past 6pm???
      const visitDate = this.form.visiting_date
      const validDate = this.form.validity_date

      const visitTime = this.form.visit_time
      const validTime = this.form.valid_time

      this.epochVisitDateTime = date.convertDateTimeToUnix(visitDate, visitTime)
      this.epochValidDateTime = date.convertDateTimeToUnix(validDate, validTime)

      const disposalDate = this.form.disposal_date
      const disposalByNum = disposalDate.split(' ')[0]
      const disposalByPeriod = disposalDate.split(' ')[1]
      this.epochDisposalDate = date.addDaysToDate(validDate, disposalByNum, disposalByPeriod)

      // check if epochVisitDateTime is not today or future date
      if (!date.compareEpochDateToday(this.epochVisitDateTime)) {
        this.error.visit_date =
          'Please change your date to future date/time from the time you are creating this pass.'
        this.haveError = true
      }
      // display if validDateTime is overlapping epochVisitDateTime
      if (!date.compareTwoEpochDate(this.epochVisitDateTime, this.epochValidDateTime)) {
        this.error.valid_date =
          'Please change pass validity date coz it\'s overlapping the visiting time'
        this.haveError = true
      }

      // check if visitDate or validDate is more than 3 months
      if (!date.checkIfDateIsPastMonths(visitDate) || !date.checkIfDateIsPastMonths(validDate)) {
        this.error.visit_date =
          'Currently, you can only create a pass within 3 months from the date today. ' +
          'Please change date to less than 3 months. If you need to create pass for more than 3 month, '+
          'send us an email at team@yeypass.com.'
        this.haveError = true
      }

      if (this.form.included_pass_details.length === 0) {
        this.error.included_pass_details =
          'Please choose details that you want to include in this pass'
        this.haveError = true
      }

      if (this.form.visiting_agreements.length === 0) {
        this.error.visiting_agreements =
          'Please choose visiting agreements that you want to include in this pass'
        this.haveError = true
      }

      if (this.form.request_access && this.form.pass_intro === '') {
        this.error.pass_intro = 'Please fill-in pass intro'
        this.haveError = true
      }

      if(this.form.pass_access_questions.length === 1) {
        if(this.form.pass_access_questions[0].question === '')
          this.form.pass_access_questions[0].question = 'none'
      }

      if (this.haveError || this.isInvalidVuelidate) {
        this.error_message = 'You might have missed out a field. ' +
          'Please check the errors shown and update the details. Thank you! :)'
      }
      else this.postFields()
    },
    async postFields() {
      this.requestInProgress = true
      let fields = { ...this.form, owner_id: this.userId }
      fields = common.deleteByObjKey(fields, 'visit_time')
      fields = common.deleteByObjKey(fields, 'valid_time')

      fields.disposal_period = this.epochDisposalDate
      fields.valid_from = this.epochVisitDateTime
      fields.valid_until = this.epochValidDateTime
      fields.visiting_date = date.convertDate(this.form.visiting_date)
      fields.visiting_time = date.convertTime(this.form.visit_time)
      fields.validity_date = date.convertDate(this.form.validity_date)
      fields.validity_time = date.convertTime(this.form.valid_time)
      fields.pass_status = 'Pending'
      fields.pass_intro = this.form.request_access ? this.form.pass_intro : 'none'
      fields.pass_access_questions = this.form.pass_access_questions
      fields.contact_email = this.form.contact_email.toLowerCase()
      fields.building_name = this.form.building_name
      fields.building_address = this.form.building_address

      try {
        const createPass = await api.createBusinessPasses(fields)
        this.requestInProgress = false
        if(createPass.statusCode === 200) this.redirectToPage()
        else this.errro_message = createPass.message
      } catch(err) {
        this.requestInProgress = false
        this.error_message = err.message
      }
    },
    redirectToPage() {
      this.$router.push('/dashboard/passes')
    },
    redirectToLogin() {
      auth.logout()
      this.$router.push('/login')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/create/CreatePass.vue